import React from "react";

export default function PageHeadline({ title, fontProps = 'default', isRegistration = false }) {
    return (
        <div className="relative">
            {isRegistration ? (
                <div className="w-fit bg-white px-4 py-2 drop-shadow-2xl border-4 border-[#164481] font-superWonder">
                    {fontProps === 'default' ?
                        <h1 className="xl:text-6xl text-2xl md:text-4xl font-superWonder font-bold uppercase text-[#164481] tracking-wider">
                            {title}
                        </h1> : <h1 className="md:text-4xl text-2xl font-superWonder font-bold italic uppercase text-[#164481] tracking-wider">
                            {title}
                        </h1>}
                </div>
            ) : (
                    <div className="w-fit bg-brandBlue px-4 py-2 font-superWonder">
                        {fontProps === 'default' ?
                            <h1 className="xl:text-6xl text-2xl md:text-4xl font-superWonder font-bold uppercase text-brandYellow tracking-wider">
                                {title}
                            </h1> : <h1 className="md:text-4xl text-2xl font-superWonder font-bold italic uppercase text-brandYellow tracking-wider">
                                {title}
                            </h1>}
                    </div>
            )}
        </div>
    );
}
